import * as partsConstants from '../../utils/partsToShow/partsConstants';
import * as sidebarSectionConstants from '../../utils/partsToShow/sidebarSectionConstants';
import { valueof } from 'src/Library/Types';

export const applestoreUrl = 'https://apps.apple.com/app/id1535761932';
export const playstoreURL = 'https://play.google.com/store/apps/details?id=in.llama.shipsy';

const inquiryLogoUrl = 'https://shipsy-public-assets.s3.us-west-2.amazonaws.com/generic/Inquiry.png';
const invoiceLogoUrl = 'https://shipsy-public-assets.s3.us-west-2.amazonaws.com/generic/Invoice.png';
const executionLogoUrl = 'https://shipsy-public-assets.s3.us-west-2.amazonaws.com/generic/Execution+(1).png';
const rateMasterLogoUrl = 'https://shipsy-public-assets.s3.us-west-2.amazonaws.com/generic/Rate+Master.png';
const trackingLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-ca0a56bd-e066-4e0e-9fbe-0df59632d0d4.png';
const bulkRequestLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-4f10c35b-852d-4961-8078-a1566737a6f3.png';
const quoteLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-2e6e30ec-363b-495e-a27d-d69fd560c7c7.png';
const discoverRatesLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-f02b647b-428d-45c4-9ce4-f4d8227ea793.png';
const procureLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-1d17813e-3335-469b-8b35-24c24209919b.png';
const vesselScheduleLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-2773aa9b-4d96-463a-adee-fc406b4906cd.png';
const rfqLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-f805e362-a6cb-4ae1-844b-7f813b012d78.png';
const containerTriangulationLogoUrl = 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-f7a46dea-e907-4740-b58d-f0b3374607dd.png';

export const sectionIcons = {
  [sidebarSectionConstants.SHIPPING_MANAGEMENT]: trackingLogoUrl,
  [partsConstants.CONTAINER_TRACKING]: trackingLogoUrl,
  [sidebarSectionConstants.RFQ]: rfqLogoUrl,
  [sidebarSectionConstants.BIDDING]: rfqLogoUrl,
  [sidebarSectionConstants.INQUIRY]: inquiryLogoUrl,
  [partsConstants.INQUIRY_SHIPPER]: procureLogoUrl,
  [sidebarSectionConstants.PROCURE]: procureLogoUrl,
  [partsConstants.INQUIRY_FF]: quoteLogoUrl,
  [sidebarSectionConstants.INVOICE]: invoiceLogoUrl,
  [sidebarSectionConstants.EXECUTION]: executionLogoUrl,
  [partsConstants.SHIP_EXEC_SHIPPER]: executionLogoUrl,
  [partsConstants.VESSEL_SCHEDULES]: vesselScheduleLogoUrl,
  [partsConstants.DISCOVER_RATES]: discoverRatesLogoUrl,
  [partsConstants.BULK_REQUEST]: bulkRequestLogoUrl,
  [sidebarSectionConstants.TRIANGULATION]: containerTriangulationLogoUrl,
  [partsConstants.RATE_MASTER]: rateMasterLogoUrl,
};

export const websiteLinks = {
  [sidebarSectionConstants.PROCURE]: 'https://share.hsforms.com/1L8ovRvV7QuSkYiXf-NUesA1t71k',
  [sidebarSectionConstants.EXECUTION]: 'https://share.hsforms.com/1L8ovRvV7QuSkYiXf-NUesA1t71k',
  [sidebarSectionConstants.RATE_MASTER]: 'https://share.hsforms.com/1L8ovRvV7QuSkYiXf-NUesA1t71k',
  [sidebarSectionConstants.INVOICE]: 'https://share.hsforms.com/1L8ovRvV7QuSkYiXf-NUesA1t71k',
  [sidebarSectionConstants.RFQ]: 'https://share.hsforms.com/1L8ovRvV7QuSkYiXf-NUesA1t71k',
}

export const quickLinks: valueof<typeof partsConstants>[] = [
  partsConstants.DISCOVER_RATES,
  partsConstants.VESSEL_SCHEDULES,
  partsConstants.RFQ_SHIPPER_OCEAN_FREIGHT,
  partsConstants.HOME,
];
export const homequickLink: valueof<typeof partsConstants>[] = [
  partsConstants.HOME,
];
export const linksToHide: valueof<typeof sidebarSectionConstants>[] = [
  sidebarSectionConstants.MY_ACCOUNT,
  sidebarSectionConstants.SETUP,
];

export const paidFeatures: valueof<typeof sidebarSectionConstants>[] = [
  sidebarSectionConstants.PROCURE,
  sidebarSectionConstants.EXECUTION,
  sidebarSectionConstants.RATE_MASTER,
  sidebarSectionConstants.INVOICE,
  sidebarSectionConstants.RFQ,
];
